import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { mapResponsiveStyles } from '@fiverr-private/theme';
import { type ChoiceGroupProps } from './types';
import useChoiceGroup from './hooks/useChoiceGroup';
import { ChoiceGroupContext } from './ChoiceGroupContext';

const ChoiceGroup = <T extends object>({
  onChange,
  onBlur,
  value,
  multiple = false,
  fill = false,
  direction = { default: 'row' },
  size,
  children,
  innerRef,
  overflowStrategy = 'wrap',
  ...rest
}: ChoiceGroupProps<T>) => {
  const contextValue = useChoiceGroup({ onChange, value, multiple, size, fill });

  return (
    <ChoiceGroupContext value={contextValue}>
      <Stack
        tabIndex={-1}
        direction={direction}
        onBlur={onBlur}
        role="group"
        ref={innerRef}
        wrap={mapResponsiveStyles(overflowStrategy, (value) => (value === 'wrap' ? 'wrap' : 'nowrap'))}
        overflowX={mapResponsiveStyles(overflowStrategy, (value) => (value === 'scroll' ? 'scroll' : 'visible'))}
        padding={mapResponsiveStyles(overflowStrategy, (value) => (value === 'scroll' ? '1' : '0'))}
        paddingBottom={mapResponsiveStyles(overflowStrategy, (value) => (value === 'scroll' ? '3' : '0'))}
        {...rest}
      >
        {children}
      </Stack>
    </ChoiceGroupContext>
  );
};

ChoiceGroup.displayName = 'ChoiceGroup';
export default ChoiceGroup;
